import { computed } from 'vue';

import useLivePortfolioQuery from './useLivePortfolioQuery';

export type TreeMapDataType = {
  name: string;
  children: {
    percent: string | undefined;
    value: number;
    name: string | null;
    isin: string | null;
  }[];
};

export default function usePortfolioMap() {
  const {
    symbols,
    isSuccessLoadingPortfolio,
    isLoadingSymbols,
    isErrorLoadingPortfolio,
    getPortfolio,
  } = useLivePortfolioQuery();

  const portfolioMap = computed<TreeMapDataType>(() => ({
    name: '',
    children: symbols.value.map((symbol) => ({
      percent: symbol.returnValuePercentage?.toFixed(2),
      value: symbol.value,
      name: symbol.instrumentName,
      isin: symbol.instrumentIsin,
    })),
  }));

  return {
    portfolioMap,
    isSuccessLoadingPortfolio,
    isLoadingSymbols,
    isErrorLoadingPortfolio,
    getPortfolio,
  };
}
